export const formatToUppercase = (handleChange, e) => {
    const event = e;
    const valueUppercase = e.target.value.toUpperCase();
    // let maskedPostcode = valueUppercase;

    // if(valueUppercase.length < 7) {
    //     maskedPostcode = valueUppercase.replace(' ', '');
    // }
    //
    // if(valueUppercase.length === 7) {
    //     if(!/\s/g.test(valueUppercase[4])) {
    //         maskedPostcode = `${valueUppercase.substring(0, 4)} ${valueUppercase.substring(4, 7)}`;
    //     }
    // }
    //
    // if(valueUppercase.length === 6 && !parseInt(valueUppercase[4]) && !/\s/g.test(valueUppercase[4])) {
    //     if(!/\s/g.test(valueUppercase[3])) {
    //         maskedPostcode = `${valueUppercase.substring(0, 3)} ${valueUppercase.substring(3, 6)}`;
    //     }
    // }

    event.target.value = valueUppercase;

    return handleChange(event);
}
